import React from 'react';
import './Card.css'; // Import the CSS file

import feature1 from '../../img/features/1.jpg';
import feature2 from '../../img/features/2.jpg';
import feature3 from '../../img/features/3.jpg';
import feature4 from '../../img/features/4.jpg';
import feature5 from '../../img/features/5.jpg';
import feature6 from '../../img/features/6.jpg';

const Card = ({ imgSrc, title, subtitle, paragraph }) => {
  return (
    <div className="card">
      <div className="poster">
        <img src={imgSrc} alt={title} />
      </div>
      <div className="details">
        <h1 className='font-ttsquare'>{title}</h1>
        <h2>{subtitle}</h2>
        <p className="desc text-left font-varelaround">
          {paragraph}
        </p>
      </div>
    </div>
  );
};

const CardWrapper = () => {
  return (
    <>
      <div className="wrapper mt-8">
        <Card
          imgSrc={feature1}
          title="Project Development"
          paragraph="Students collaborate on real-world projects, enhancing problem-solving and coding skills while building practical solutions using diverse technologies."
        />
        <Card
          imgSrc={feature2}
          title="Community Outreach"
          paragraph="Organizes tech workshops, seminars, and webinars to share knowledge, promote digital literacy, and connect with the broader tech community."
        />
        <Card
          imgSrc={feature3}
          title="UI/UX Design"
          paragraph="Fosters creativity and innovation by focusing on intuitive and user-friendly design principles for websites and mobile applications."
        />
      </div>

      <div className="wrapper mb-8">
        <Card
          imgSrc={feature4}
          title="Research"
          paragraph="Encourages students to explore emerging technologies, engage in research papers, and contribute to academic and industrial advancements."
        />
        <Card
          imgSrc={feature5}
          title="Podcast"
          paragraph="Hosts informative podcasts featuring experts and students, discussing the latest trends, experiences, and insights from the world of technology."
        />
        <Card
          imgSrc={feature6}
          title="Digital Marketing"
          paragraph="Develops digital marketing strategies, focusing on SEO, content creation, and social media campaigns to promote events and grow the chapter's online presence."
        />
      </div>
    </>
  );
};

export default CardWrapper;
